import React from 'react';
import {FormattedMessage} from "react-intl";

export function AmountWithVATColumnFormatter(cellContent) {
  const amount = cellContent.amount;
  const vat = cellContent.vat;

  return (
    <span dir='ltr' className="text-dark-75 font-weight-bolder d-block font-size-lg text-nowrap">
      <div>{amount ? parseFloat(amount).toFixed(2) : ''}</div>
      <div>
        {
          vat === 0
            ? (
              <div className={'text-danger'}>
                <FormattedMessage
                  id="invoices-amount-vatExcluded"
                  defaultMessage="Excluding VAT"
                />
              </div>
            )
            : (
              <div className={'text-success'}>
                <FormattedMessage
                  id="invoices-amount-vatIncluded"
                  defaultMessage="Including VAT"
                />
              </div>
            )
        }
      </div>
    </span>
  );
}
